function internalSetupMobileMenu () {
  console.log('Hello from mobileMenu.js v2')
  const mobileMenuButton = document.querySelector('.mega-menu__mobile-button')
  const mobileMenuRootElement = document.getElementById('mobile-menu-root')
  const sourceTray = document.querySelector('.mega-menu__mobile-tray')
  const closeButton = document.getElementById('mobile-menu-close')

  // mobileMenuButton.addEventListener('click', () => {
  //   toggleMobileMenu()
  // })

  if (mobileMenuRootElement) {
    if (sourceTray) {
      mobileMenuRootElement.appendChild(sourceTray)
      setupShowHideForMenuItems(mobileMenuRootElement)
    } else {
      console.error('sourceTray not found!')
    }
  } else {
    console.error('mobileMenuRootElement not found!')
  }

  if (closeButton) {
    closeButton.addEventListener('pointerdown', () => {
      hideMobileMenu()
    })
  } else {
    console.error('closeButton not found.')
  }

  if (mobileMenuButton) {
    mobileMenuButton.addEventListener('pointerdown', () => {
      toggleMobileMenu()
    })
  } else {
    console.error('mobileMenuButton not found!')
  }

  function showMobileMenu () {
    mobileMenuRootElement.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }
  function hideMobileMenu () {
    mobileMenuRootElement.classList.add('hidden')
    document.body.style.overflow = 'unset'
  }
  function toggleMobileMenu () {
    if (isShown()) {
      hideMobileMenu()
    } else {
      showMobileMenu()
    }
  }
  function isShown () {
    return mobileMenuRootElement.classList.contains('hidden') === false
  }
}

function setupShowHideForMenuItems(mobileMenuRootElement){
  const itemsWithChildren = mobileMenuRootElement.querySelectorAll(':scope .mobile-menu-list__item--with-children')
  for(const itemWithChildren of itemsWithChildren){
    setupItemWithChildren(itemWithChildren)
  }
}

function setupItemWithChildren(item){
  const toggleButtonElement = item.querySelector(':scope .mobile-menu-list__toggle-button')
  const listOfChildren = item.querySelector(':scope .mobile-menu-list')
  if(toggleButtonElement){
    toggleButtonElement.addEventListener('pointerdown', event => {
      if(listOfChildren){
        listOfChildren.classList.toggle('visible')
        if(listOfChildren.classList.contains('visible')){
          toggleButtonElement.innerText = "-"
        }else{
          toggleButtonElement.innerText = "+"
        }
      }
    })
  }
  console.log({ itemWithChildren: item })
}

export function setupMobileMenu () {
  internalSetupMobileMenu()
}

// document.addEventListener('DOMContentLoaded', function () {
//   setupMobileMenu()
// })
